import { render } from "./HFO_BI_002_KBPRM.vue?vue&type=template&id=0316b1f0&scoped=true"
import script from "./HFO_BI_002_KBPRM.vue?vue&type=script&lang=js"
export * from "./HFO_BI_002_KBPRM.vue?vue&type=script&lang=js"

import "./HFO_BI_002_KBPRM.vue?vue&type=style&index=0&id=0316b1f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0316b1f0"]])

export default __exports__